export default __webpack_public_path__ + "static/media/star_wars_logo.e3b54fcc.svg";